import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
import { TermToolCondition } from '../term-tool.condition';
import { TermToolItem } from '../term-tool.item';
declare var $: any;

@Component({
    selector: 'app-term-item',
    templateUrl: './term-item.component.html',
    styleUrls: ['./term-item.component.css']
})
export class TermItemComponent implements OnInit {

    @Input() adjustmentId = '';
    @Input() dataRobotModels: any[] = [];
    @Input() operators: any[] = [];
    @Input() attributes: any[] = [];

    @Output() itemLoaded = new EventEmitter<void>();
    @Output() getAdjustmentsList = new EventEmitter<any>();
    @Output() showErrorMessage = new EventEmitter<string>();

    activeAdjustment: TermToolItem | any = {};
    customLogicSelected = false;
    addCustomLogicSubmitted = false;
    disabledFields = true;
    addNewConditionSubmitted = false;
    adjustmentsForm: FormGroup;
    newConditionForm: FormGroup;

    constructor(
        private connectionService: ConnectionService,
        private formBuilder: FormBuilder
    ) {
        this.adjustmentsForm = new FormGroup({
            adjustmentPriority: new FormControl(),
            adjustmentMinTerm: new FormControl(),
            adjustmentMiddleTerm: new FormControl(),
            adjustmentMaxTerm: new FormControl(),
            dataRobotModelSelect: new FormControl(),
            adjustmentLogic: new FormControl(),
            customLogic: new FormControl('', Validators.required),
            statusSwitch: new FormControl()
        });

        this.newConditionForm = this.formBuilder.group({
            description: ['', Validators.required],
            operator: ['', Validators.required],
            value: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        this.disableFields();
        this.adjustmentsForm.controls.statusSwitch.patchValue(true);
        this.getAdjustmentDetailAux(this.adjustmentId).then(
            () => this.itemLoaded.emit()
        );
    }

    onChangeDataRobotModel() {
        return new Promise((resolve, reject) => {
            const postData: any = {
                dataRobotModelId: this.adjustmentsForm.controls.dataRobotModelSelect.value.id,
                id: Number(this.adjustmentId)
            };
            this.connectionService.postRequest(`${environment.gateway}offertermadjustment/dataRobotModel`, postData, 'application/json').subscribe(
                (data: any) => {
                    this.resolveSuccess(resolve, data);
                },
                (error: any) => {
                    this.resolveError(reject, error);
                }
            );
        });
    }

    getAdjustmentDetailAux(pModelId: string) {
        return new Promise((resolve, reject) => {
            this.getAdjustmentDetail(pModelId).then(
                (data: TermToolItem) => {
                    this.activeAdjustment = data;
                    data.active ? this.disableFields() : this.enableFields();
                    this.adjustmentsForm.controls.statusSwitch.patchValue(data.active);
                    this.adjustmentsForm.controls.adjustmentPriority.patchValue(data.priority);
                    this.adjustmentsForm.controls.adjustmentMinTerm.patchValue(data.minimumTerm);
                    this.adjustmentsForm.controls.adjustmentMiddleTerm.patchValue(data.middleTerm);
                    this.adjustmentsForm.controls.adjustmentMaxTerm.patchValue(data.maxTerm);
                    this.adjustmentsForm.controls.dataRobotModelSelect.patchValue(null);
                    this.customLogicSelected = false;
                    this.addCustomLogicSubmitted = false;
                    this.adjustmentsForm.controls.customLogic.patchValue('');

                    let logic = String(data.logic);
                    if (data.logicType === 'CUSTOM') {
                        this.customLogicSelected = true;
                        this.adjustmentsForm.controls.customLogic.patchValue(logic);
                    }
                    this.adjustmentsForm.controls.adjustmentLogic.patchValue(data.logicType);
                    for (var i = this.dataRobotModels.length - 1; i >= 0; i--) {
                        if (this.dataRobotModels[i].id === data.dataRobotModelId) {
                            this.adjustmentsForm.controls.dataRobotModelSelect.patchValue(this.dataRobotModels[i]);
                            break;
                        }
                    }
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    }

    getAdjustmentDetail(adjustmentId: string) {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(`${environment.gateway}offertermadjustment/detail/${adjustmentId}`, 'application/json').subscribe(
                (data: any) => {
                    const pricingAdjustment: TermToolItem = new TermToolItem(data.object, this.attributes, this.operators, this.dataRobotModels);
                    resolve(pricingAdjustment);
                },
                (error: any) => {
                    this.showErrorMessage.emit(error.error.msg);
                    reject(error);
                }
            );
        });
    }

    onChangeAdjustmentMinTerm() {
        return new Promise((resolve, reject) => {
            const postData: any = {
                minimumTerm: this.adjustmentsForm.controls.adjustmentMinTerm.value,
                id: Number(this.adjustmentId)
            };
            this.connectionService.postRequest(`${environment.gateway}offertermadjustment/minterm`, postData, 'application/json').subscribe(
                (data: any) => {
                    this.resolveSuccess(resolve, data);
                },
                (error: any) => {
                    this.resolveError(reject, error);
                }
            );
        });
    }

    onChangeAdjustmentMiddleTerm() {
        return new Promise((resolve, reject) => {
            const postData: any = {
                middleTerm: this.adjustmentsForm.controls.adjustmentMiddleTerm.value,
                id: Number(this.adjustmentId)
            };
            this.connectionService.postRequest(`${environment.gateway}offertermadjustment/middleterm`, postData, 'application/json').subscribe(
                (data: any) => {
                    this.resolveSuccess(resolve, data);
                },
                (error: any) => {
                    this.resolveError(reject, error);
                }
            );
        });
    }

    onChangeAdjustmentMaxTerm() {
        return new Promise((resolve, reject) => {
            const postData: any = {
                maxTerm: this.adjustmentsForm.controls.adjustmentMaxTerm.value,
                id: Number(this.adjustmentId)
            };
            this.connectionService.postRequest(`${environment.gateway}offertermadjustment/maxterm`, postData, 'application/json').subscribe(
                (data: any) => {
                    this.resolveSuccess(resolve, data);
                },
                (error: any) => {
                    this.resolveError(reject, error);
                }
            );
        });
    }

    onChangeAdjustmentPriority() {
        return new Promise((resolve, reject) => {
            const postData: any = {
                priority: this.adjustmentsForm.controls.adjustmentPriority.value,
                id: Number(this.adjustmentId)
            };
            this.connectionService.postRequest(`${environment.gateway}offertermadjustment/priority`, postData, 'application/json').subscribe(
                (data: any) => {
                    this.resolveSuccess(resolve, data);
                },
                (error: any) => {
                    this.resolveError(reject, error);
                }
            );
        });
    }

    onChangeAdjustmentStatus() {
        this.disableFields();
        return new Promise((resolve, reject) => {
            const postData: any = {
                active: this.adjustmentsForm.controls.statusSwitch.value,
                id: Number(this.adjustmentId)
            };
            this.connectionService.postRequest(`${environment.gateway}offertermadjustment/status/`, postData, 'application/json').subscribe(
                (data: any) => {
                    this.resolveSuccess(resolve, data);
                },
                (error: any) => {
                    this.resolveError(reject, error);
                }
            );
        });
    }

    onChangeAdjustmentLogic(temp: string) {
        let logicToUse = '';
        if (this.customLogicSelected && temp === 'CUSTOM') {
            this.addCustomLogicSubmitted = true;
            if (this.adjustmentsForm.invalid) {
                return;
            }
            logicToUse = this.adjustmentsForm.controls.customLogic.value;
        } else if (temp === 'CUSTOM') {
            this.customLogicSelected = true;
            return;
        } else {
            this.customLogicSelected = false;
            this.addCustomLogicSubmitted = false;
            if (this.activeAdjustment.conditions.length <= 1) {
                logicToUse = '1';
            } else {
                var tempL = Array.from({ length: this.activeAdjustment.conditions.length }, (_, i) => i + 1);
                if (temp === 'ALL_AND') {
                    logicToUse = tempL.join(' AND ');
                }
                if (temp === 'ALL_OR') {
                    logicToUse = tempL.join(' OR ');
                }
            }
        }
        return new Promise((resolve, reject) => {
            const postData: any = {
                logic: logicToUse,
                logicType: temp,
                id: Number(this.adjustmentId)
            };
            this.connectionService.postRequest(`${environment.gateway}offertermadjustment/logic`, postData, 'application/json').subscribe(
                (data: any) => {
                    this.resolveSuccess(resolve, data);
                },
                (error: any) => {
                    this.resolveError(reject, error);
                }
            );
        });
    }

    onRemoveClick(condition: TermToolCondition) {
        if (this.activeAdjustment.active) {
            return;
        } else {
            return new Promise((resolve, reject) => {
                const postUrl = `${environment.gateway}/offertermadjustment/remove/${condition.offerTermAdjustmentId}/${condition.id}`;
                this.connectionService.deleteRequest(postUrl, 'application/json').subscribe(
                    (data: any) => {
                        this.resolveSuccessNoAdjustmentsEmit(resolve, data);
                    },
                    (error: any) => {
                        this.resolveErrorNoAdjustmentsEmit(reject, error);
                    }
                );
            });
        }
    }

    onCreateNewConditionSubmit() {
        this.addNewConditionSubmitted = false;
        this.newConditionForm.controls.description.setValue('');
        this.newConditionForm.controls.operator.setValue('');
        this.newConditionForm.controls.value.setValue('');
        $('#addNewAdjustmentConditionModal').modal();
    }

    onCreateConditionSubmit() {
        this.addNewConditionSubmitted = true;
        if (this.newConditionForm.invalid) {
            return;
        }

        $('#addNewAdjustmentConditionModal').modal('hide');
        return new Promise((resolve, reject) => {
            const postData: any = {
                offerTermAdjustmentId: Number(this.adjustmentId),
                dataRobotAttributeId: this.newConditionForm.controls.description.value.id,
                operatorId: this.newConditionForm.controls.operator.value.id,
                value: this.newConditionForm.controls.value.value,
                conditionIdentifier: Number(this.activeAdjustment.conditions.length + 1)
            };
            this.connectionService.postRequest(`${environment.gateway}offertermCondition`, postData, 'application/json').subscribe(
                (data: any) => {
                    this.resolveSuccessNoAdjustmentsEmit(resolve, data);
                },
                (error: any) => {
                    this.resolveErrorNoAdjustmentsEmit(reject, error);
                }
            );
        });
    }

    private resolveSuccess(resolve: (value: unknown) => void, data: any) {
        this.getAdjustmentDetailAux(this.adjustmentId);
        this.getAdjustmentsList.emit(this.adjustmentId);
        resolve(data);
    }

    private resolveError(reject: (reason?: any) => void, error: any) {
        this.getAdjustmentDetailAux(this.adjustmentId);
        this.getAdjustmentsList.emit(this.adjustmentId);
        this.showErrorMessage.emit(error.error.msg);
        reject(error);
    }

    private disableFields() {
        this.disabledFields = true;
        this.adjustmentsForm.controls.adjustmentPriority.disable();
        this.adjustmentsForm.controls.adjustmentMinTerm.disable();
        this.adjustmentsForm.controls.adjustmentMiddleTerm.disable();
        this.adjustmentsForm.controls.adjustmentMaxTerm.disable();
        this.adjustmentsForm.controls.dataRobotModelSelect.disable();
        this.adjustmentsForm.controls.adjustmentLogic.disable();
        this.adjustmentsForm.controls.customLogic.disable();
    }

    private enableFields() {
        this.disabledFields = false;
        this.adjustmentsForm.controls.adjustmentPriority.enable();
        this.adjustmentsForm.controls.adjustmentMinTerm.enable();
        this.adjustmentsForm.controls.adjustmentMiddleTerm.enable();
        this.adjustmentsForm.controls.adjustmentMaxTerm.enable();
        this.adjustmentsForm.controls.dataRobotModelSelect.enable();
        this.adjustmentsForm.controls.adjustmentLogic.enable();
        this.adjustmentsForm.controls.customLogic.enable();
    }

    private resolveSuccessNoAdjustmentsEmit(resolve: (value: unknown) => void, data: any) {
        this.getAdjustmentDetailAux(this.adjustmentId);
        resolve(data);
    }

    private resolveErrorNoAdjustmentsEmit(reject: (reason?: any) => void, error: any) {
        this.getAdjustmentDetailAux(this.adjustmentId);
        this.showErrorMessage.emit(error.error.msg);
        reject(error);
    }
}